import { EDirectoryPreferences } from "../interface/INDDPreference";

export interface IDirectoryPreferencesResponse {
    nddPreference: EDirectoryPreferences;
}

export const getResponseToState = (response: IDirectoryPreferencesResponse): EDirectoryPreferences =>
    response.nddPreference;

export interface IDirectoryPreferencesPayload {
    nddPreference: EDirectoryPreferences;
}

export const getStateToPayload = (nationalDirectoryName: EDirectoryPreferences): IDirectoryPreferencesPayload => ({
    nddPreference: nationalDirectoryName,
});
